<script setup lang="ts">
import ProgressBar from '@/components/lib/ProgressBar.vue'
import GwTooltip from '@/components/lib/GwTooltip.vue'

withDefaults(
  defineProps<{
    isPending: boolean
    currentSolutionsCount: number
    totalBoardCount: number
    isDisabled?: boolean
  }>(),
  {
    isPending: true,
    currentSolutionsCount: 0,
    totalBoardCount: 0,
  },
)
</script>

<template>
  <div
    class="gw_loading study-reports-loader"
    style="position: relative"
  >
    <ProgressBar
      class="background-pulsing-bar"
      :class="isDisabled ? 'disabled' : ''"
      :progress="!isDisabled ? 100 : 0"
      :transitionSpeed="0"
    />
    <ProgressBar
      class="main-progress-bar"
      :class="isDisabled ? 'disabled' : ''"
      :progress="currentSolutionsCount"
      :maxProgress="totalBoardCount"
      :transitionSpeed="0.5"
    />

    <div
      v-if="!isDisabled"
      class="d-flex inner-content"
    >
      <div class="d-flex inner-content-text">
        <span v-if="!isPending">{{ currentSolutionsCount }} / {{ totalBoardCount }}</span>
        <span v-else>{{ $t('messages.loading_custom_reports') }}</span>
      </div>
      <GwTooltip
        class="gw_hvr_content ml-1"
        :tooltip="$t('tooltips.reports_loading')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.study-reports-loader {
  gap: var(--gap);
  margin: 0;
}

.main-progress-bar {
  align-self: center;
  --height: 1.5rem;
  --clr-back: transparent;
}

.background-pulsing-bar {
  animation: pulse 2s ease-in-out infinite;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-self: center;
  --height: 1.5rem;
  opacity: 0.2;
}

.inner-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  text-wrap: nowrap;
  font-size: 0.75rem;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.inner-content-text {
  justify-content: right;
  font-weight: 500;
  text-shadow: var(--text-shadow_drop);
}

@media (min-width: 1024px) {
  .study-reports-loader {
    margin: 0.05rem 0 -0.25rem 0;
  }
}

.disabled {
  opacity: 0.44 !important;
  background-color: var(--clr-black-1-3) !important;
}

@keyframes pulse {
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.05;
  }
  100% {
    opacity: 0.2;
  }
}
</style>
